var _rect, _rect2, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMiniMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 127,
    height: 65,
    viewBox: "0 0 127 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 126,
    width: 10,
    height: 113,
    rx: 2,
    transform: "rotate(90 126 0)",
    fill: "#7EA6FF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 49,
    height: 113,
    rx: 2,
    transform: "matrix(8.70218e-08 -1 -1 -2.19564e-08 126 64)",
    fill: "#F5F5F5",
    fillOpacity: 0.4,
    stroke: "#7EA6FF",
    strokeDasharray: "1 1"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 64,
    rx: 1,
    fill: "#4680FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMiniMenu);
export default __webpack_public_path__ + "static/media/mini-menu.e9b2316774eb1a5ef8cbacde77d433fc.svg";
export { ForwardRef as ReactComponent };